import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import Calendar from './Calendar';

export default function action({ store }) {

  // From Redux Store
  const isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title: 'Calendar',
    component: <UserLayout><Calendar /></UserLayout>,
  };
}
